<template>
  <span class="stein" :style="styPos" @click="$emit('stein-aktiv',  {i: bild, x: x, y: y})">
    <img v-if="hasBild"  :class="clActive"  :src="imgStein" @dragstart="prevDefault">
  </span>
</template>

<script setup>
import { ref, computed } from 'vue';
import {bildSrc} from '@/helper/bilder'

	const props = defineProps({
    bild: Number,
    aktiv: Number,
		thema: Number,
    x: Number,
    y: Number,
	});
	defineEmits(['stein-aktiv'])
	const hasBild = computed(() => props.bild > 10 );
	const clActive = computed(() => props.aktiv ? 'active' : 'inactive');
	const styPos = computed(() => 'left:' + ((props.x - 1) * 5.4) + '%');
	const imgStein = computed(() => bildSrc[props.thema][props.bild]);

  function prevDefault(ev) {
		ev.preventDefault()
  }
</script>

